import { BookOpenText, Files, Home, LibraryBig, MessageSquareText } from "lucide-react";
import { NavLink } from "react-router-dom";

const items = [
  { to: "/", label: "Главная", icon: Home, end: true },
  { to: "/passport", label: "Паспорт", icon: BookOpenText },
  { to: "/facts", label: "Факты", icon: LibraryBig },
  { to: "/wording", label: "Тексты", icon: MessageSquareText },
  { to: "/assets", label: "Файлы", icon: Files },
];

export function MobileNavigation() {
  return (
    <nav className="mobile-nav" aria-label="Основная навигация">
      {items.map(({ to, label, icon: Icon, end }) => (
        <NavLink key={to} to={to} end={end} className={({ isActive }) => `mobile-nav__item ${isActive ? "is-active" : ""}`}>
          <Icon size={20} strokeWidth={1.8} aria-hidden="true" />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
